import React, { FunctionComponent } from 'react'
import Svg, { Line } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils'

export const WaveFormIcon: FunctionComponent<WaveFormIconProps> = ({ size = 16, fillColor }) => {
  const { colors } = useTheme()

  return (
    <Svg width={size} height={size} viewBox='0 0 16 16' fill='none' testID={tID('WaveFormIcon')}>
      <Line
        x1='1.375'
        y1='9.375'
        x2='1.375'
        y2='6.625'
        stroke={fillColor || colors.iconDefault}
        strokeWidth='1.25'
        strokeLinecap='round'
      />
      <Line
        x1='6.375'
        y1='15.375'
        x2='6.375'
        y2='0.625'
        stroke={fillColor || colors.iconDefault}
        strokeWidth='1.25'
        strokeLinecap='round'
      />
      <Line
        x1='8.875'
        y1='11.375'
        x2='8.875'
        y2='4.625'
        stroke={fillColor || colors.iconDefault}
        strokeWidth='1.25'
        strokeLinecap='round'
      />
      <Line
        x1='3.875'
        y1='12.375'
        x2='3.875'
        y2='3.625'
        stroke={fillColor || colors.iconDefault}
        strokeWidth='1.25'
        strokeLinecap='round'
      />
      <Line
        x1='11.375'
        y1='13.375'
        x2='11.375'
        y2='2.625'
        stroke={fillColor || colors.iconDefault}
        strokeWidth='1.25'
        strokeLinecap='round'
      />
      <Line
        x1='13.875'
        y1='9.375'
        x2='13.875'
        y2='6.625'
        stroke={fillColor || colors.iconDefault}
        strokeWidth='1.25'
        strokeLinecap='round'
      />
    </Svg>
  )
}

type WaveFormIconProps = {
  size?: string | number
  fillColor?: string
}
